import(/* webpackMode: "eager", webpackExports: ["FadeUp","Stagger","StaggerItem"] */ "/private/tmp/velova-production-build-95194f1/frontend/components/landing/motion-primitives.tsx");
;
import(/* webpackMode: "eager" */ "/Users/anmol/Documents/FINAL_OPEN_CLAW/geo/frontend/node_modules/next/dist/client/link.js");
